import { NameResourceItem } from "../NameResourceItem";
import { createListResource } from "../../list";
import { createFullClassResource } from "../../fullResource";

export class Language extends NameResourceItem {}

export const languageResource = createFullClassResource(
  "plm/language/",
  Language,
);
